import { WorkflowState } from '@amzn/awscat-pattern-library-service-model';

/** Deprecated peer-review states — v2 will never support these; redirect to v1. */
export const LEGACY_REDIRECT_STATES: ReadonlySet<WorkflowState> = new Set([
  WorkflowState.PENDING_REVIEW,
  WorkflowState.IN_REVIEW,
  WorkflowState.REVIEWED,
  WorkflowState.REJECTED,
]);
